import {
  IsOptional,
  IsEnum,
  IsUUID,
  IsBoolean,
  IsString,
} from 'class-validator'
import { Transform } from 'class-transformer'
import { ApiPropertyOptional } from '@nestjs/swagger'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'
import {
  AnnouncementPriority,
  AnnouncementCategory,
  AnnouncementVisibility,
  AnnouncementStatus,
} from '../../../enums'

/**
 * Parse les booléens query string ("false" ne doit pas être truthy).
 */
function parseQueryBoolean(value: unknown): boolean | undefined {
  if (value === undefined || value === null || value === '') return undefined
  if (value === true || value === 'true' || value === '1') return true
  if (value === false || value === 'false' || value === '0') return false
  return undefined
}

/**
 * DTO for listing announcements with filters
 */
export class ListAnnouncementsQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({ enum: AnnouncementPriority })
  @IsEnum(AnnouncementPriority)
  @IsOptional()
  priority?: AnnouncementPriority

  @ApiPropertyOptional({ enum: AnnouncementCategory })
  @IsEnum(AnnouncementCategory)
  @IsOptional()
  category?: AnnouncementCategory

  @ApiPropertyOptional({ enum: AnnouncementVisibility })
  @IsEnum(AnnouncementVisibility)
  @IsOptional()
  visibility?: AnnouncementVisibility

  @ApiPropertyOptional({ enum: AnnouncementStatus })
  @IsEnum(AnnouncementStatus)
  @IsOptional()
  status?: AnnouncementStatus

  @ApiPropertyOptional({ description: 'Filter by establishment ID' })
  @IsUUID()
  @IsOptional()
  establishmentId?: string

  @ApiPropertyOptional({ description: 'Filter by class ID' })
  @IsUUID()
  @IsOptional()
  classId?: string

  @ApiPropertyOptional({ description: 'Filter by author ID' })
  @IsUUID()
  @IsOptional()
  authorId?: string

  @ApiPropertyOptional({ description: 'Filter by campaign ID' })
  @IsUUID()
  @IsOptional()
  campaignId?: string

  @ApiPropertyOptional({ description: 'Include expired announcements' })
  @Transform(({ value }) => parseQueryBoolean(value))
  @IsBoolean()
  @IsOptional()
  includeExpired?: boolean

  @ApiPropertyOptional({ description: 'Include draft announcements' })
  @Transform(({ value }) => parseQueryBoolean(value))
  @IsBoolean()
  @IsOptional()
  includeDrafts?: boolean

  @ApiPropertyOptional({ description: 'Search term for title or content' })
  @IsString()
  @IsOptional()
  search?: string

  @ApiPropertyOptional({ description: 'Context establishment ID' })
  @IsUUID()
  @IsOptional()
  contextEstablishmentId?: string

  @ApiPropertyOptional({ description: 'Context class ID' })
  @IsUUID()
  @IsOptional()
  contextClassId?: string

  @ApiPropertyOptional({ description: 'Filter only unread announcements' })
  @Transform(({ value }) => parseQueryBoolean(value))
  @IsBoolean()
  @IsOptional()
  unreadOnly?: boolean
}
